<div *ngIf="SchoolReportService.isGraphEmpty" class="p-2 text-center">
    <!--No test data for these selections-->
</div>

<div *ngIf="!SchoolReportService.isGraphReset" class="text-center">
    <span [innerHTML]="SchoolReportService.title"></span>
</div>

<div *ngIf="!SchoolReportService.isGraphReset">
    <mat-tab-group color="accent" [selectedIndex]="selectedIndex" style="width:65vw;">
        <mat-tab *ngFor="let tabData of donutChartData" [label]="tabData.timePeriod">
            <ng-template matTabContent>
                <div *ngIf="tabData.isTabEmpty" class="p-2 text-center">No test data in this time period</div>

                <plotly-plot
                    *ngIf="!tabData.isTabEmpty"
                    [data]="tabData.chartData"
                    [layout]="SchoolReportService.graphLayout"
                    [config]="SchoolReportService.graphConfig"
                    [useResizeHandler]="true"
                    [divId]="'school-report-chart'"
                    (legendClick)="SchoolReportService.hideLegend($event)">
                </plotly-plot>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>
